import { useEffect } from "react";

const MobileInfoModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  // prevent background scroll when modal is open
  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-gray-900 text-white p-6 rounded-2xl w-[90%] max-w-sm shadow-xl animate-scaleIn">
        <h2 className="text-2xl font-semibold text-red-400 mb-3">Mobile Version Status</h2>

        <p className="text-gray-300 leading-relaxed mb-6">
          The mobile version of Noleyo is currently paused while we focus on delivering major improvements. 🚧
          <br />
          <br />
          We’ll be back with a faster and more polished mobile experience very soon!
        </p>

        <button onClick={onClose} className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl font-medium transition">
          Continue
        </button>
      </div>
    </div>
  );
};

export default MobileInfoModal;
